module.exports = __webpack_public_path__ + "static/media/RahatAliDar_Beena2.dd42c666.jpg";